/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { CommonModule } from '@angular/common';
import { RatingService, Rating } from '../../../../services/rating-service/rating-service';
import { GapCheckSection } from '../../../../shared/models/gap-check-section';

@Component({
  selector: 'app-summary-step',
  standalone: true,
  imports: [CommonModule, BaseChartDirective],
  templateUrl: './summary.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./summary.css'],
})
export class SummaryComponent implements OnInit {
  private ratingService = inject(RatingService);

  @Input() questions: GapCheckSection[] = [];
  @Input() currentStep = 0;

  @Input() getStepScore!: (index: number) => {
    yes: number;
    no: number;
    partial: number;
    na: number;
    total: number;
    percentage: number;
    graphic: number;
  };

  @Input() getAllScoresTotal!: () => {
    yes: number;
    no: number;
    partial: number;
    na: number;
    total: number;
    percentage: number;
    graphic: number;
  };

  totalGraphicScore = 0;
  rating: Rating | null = null;

  @Input() radarChartData: any;
  @Input() radarChartLabels: string[] = [];
  @Input() radarChartOptions: any;
  @Input() barChartData: any;
  @Input() barChartOptions: any;

  ngOnInit(): void {
    if (this.getAllScoresTotal) {
      const result = this.getAllScoresTotal();
      this.totalGraphicScore = result.graphic;

      // ✅ pass score to service
      this.rating = this.ratingService.getRating(this.totalGraphicScore);
    }
  }

  clampTarget(target: number | undefined): number {
    if (target === undefined || target === null) return 8;
    return Math.min(Math.max(target, 1), 10);
  }
}